/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/PopoverMenu'
import UserSelector from 'modules/core/components/UserSelector'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import useSelectIds from 'modules/core/hooks/useSelectIds'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import SectionButton from 'modules/questionnaires/components/Section/SectionButton'
import { useShareTaskProvider } from 'modules/tasks/components/TaskDetails/Header/Share/Provider'
import { TaskDetail } from 'modules/tasks/components/TaskElement/useTaskDetail'

interface Props {
  task: TaskDetail
}

export const Add = ({ task }: Props) => {
  const { addedSharedAccesses, addAccess } = useShareTaskProvider()

  const [selectedIds, setSelectedId, setSelectedIds] = useSelectIds()
  const [toggle, setToggle] = useState(false)

  const assigneeIds = task.assignees.map((i) => i.id)

  const usersToShow = users.notTerminated(employees).filter((i) => {
    return !assigneeIds.includes(i.id)
  })

  const submitLabel = () => {
    if (selectedIds.length == 0) return i18n.t('user_selector.submit.zero')
    return i18n.tp('user_selector.submit', {
      count: selectedIds.length,
    })
  }

  useUnsafeEffect(() => {
    setSelectedIds(addedSharedAccesses)
  }, [])

  return (
    <Box width="full">
      <Popover type="dialog" open={toggle}>
        <Popover.Trigger>
          <Box width="full" onClick={() => setToggle(true)}>
            <SectionButton icon="add" onClick={() => {}}>
              {i18n.t('tasks.share.modal.button')}
            </SectionButton>
          </Box>
        </Popover.Trigger>
        <Popover.Content
          side="bottom"
          align="start"
          width="full"
          onInteractOutside={() => setToggle(false)}
        >
          <Box width="s400" padding="s24" gap="s24">
            <UserSelector
              disabledUsers={addedSharedAccesses}
              onSelect={setSelectedId}
              onSelectMultiple={setSelectedIds}
              selectedIds={selectedIds}
              users={usersToShow}
            />
            <Button
              type="primary"
              onClick={() => {
                addAccess(selectedIds)
                setToggle(false)
              }}
            >
              {submitLabel()}
            </Button>
          </Box>
        </Popover.Content>
      </Popover>
    </Box>
  )
}
